import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function HanoverError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot create hanover widget'}
    </Alert>
  );
}

export { HanoverError };
